<template>
  <div class="channel-configuration-fields-container">
    <div v-for="selection in selectionData" :key="selection.variant" class="field-section">
      <span class="field-section-label">{{ selection.label }}</span>
      <v-select
        :value="getModel(selection.variant)"
        :class="['field-section-select', `variant-${selection.variant}`]"
        :items="selection.items"
        outlined
        dense
        @input="setModel(selection.variant, $event)"
      >
        <template #append>
          <mf-icon class="cursor-pointer" color="marca-0-l10" icon="keyboard_arrow_down" />
        </template>
      </v-select>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChannelConfigurationFields',
  props: {
    offerType: {
      type: String,
      default: 'offer_sales',
      validator: (value) =>
        [
          'offer_sales',
          'percentage_offer_sales',
          'cashback_absolute_offer_sales',
          'cashback_percentage_offer_sales',
          'takepay_offer_sales',
          'points_offer_sales',
          'combo_offer_sales',
        ].includes(value),
    },
    channel: {
      type: String,
      default: 'sms',
      validator: (value) => ['sms', 'push', 'whatsapp', 'email'].includes(value),
    },
    field: {
      type: String,
      default: 'text',
      validator: (value) => ['text', 'title', 'inner_message_title', 'inner_message_text'].includes(value),
    },
  },
  computed: {
    channelsItems() {
      return [
        { text: 'SMS', value: 'sms', disabled: false },
        { text: 'Push', value: 'push', disabled: !this.$getAllowedModules()['push'] },
        { text: 'E-mail', value: 'email', disabled: !this.$getAllowedModules()['email_v2'] },
        { text: 'Whatsapp', value: 'whatsapp', disabled: !this.$getAllowedModules()['whatsapp'] },
      ]
    },
    fieldsItems() {
      return [
        { text: 'Título', value: 'title', disabled: false },
        { text: 'Texto da notificação', value: 'text', disabled: false },
        { text: 'Título interno', value: 'inner_message_title', disabled: false },
        { text: 'Texto interno da notificação', value: 'inner_message_text', disabled: false },
      ]
    },
    offerTypeItems() {
      return [
        { text: 'Desconto absoluto', value: 'offer_sales' },
        { text: 'Desconto percentual', value: 'percentage_offer_sales' },
        { text: 'Cashback absoluto ', value: 'cashback_absolute_offer_sales' },
        { text: 'Cashback percentual ', value: 'cashback_percentage_offer_sales' },
        { text: 'Leve e pague', value: 'takepay_offer_sales' },
        { text: 'Pontos ', value: 'points_offer_sales' },
        { text: 'Combo', value: 'combo_offer_sales' },
      ]
    },
    selectionData() {
      const channelsData = {
        items: this.channelsItems,
        variant: 'channels',
        label: 'Canal',
      }
      const fieldsData = {
        items: this.fieldsItems,
        variant: 'fields',
        label: 'Campo',
      }
      const offerTypeData = {
        items: this.offerTypeItems,
        variant: 'offer-type',
        label: 'Mecânica',
      }

      const fieldsSection = this.channel === 'push' ? [fieldsData] : []

      return [channelsData, ...fieldsSection, offerTypeData]
    },
  },
  watch: {
    channel() {
      this.setModel('fields', 'text')
      this.setModel('offer-type', 'offer_sales')
    },
  },
  methods: {
    getModel(variant) {
      switch (variant) {
        case 'channels':
          return this.channel
        case 'fields':
          return this.field
        case 'offer-type':
          return this.offerType
        default:
          return ''
      }
    },
    setModel(variant, value) {
      switch (variant) {
        case 'channels':
          this.$emit('update:channel', value)
          break
        case 'fields':
          this.$emit('update:field', value)
          break
        case 'offer-type':
          this.$emit('update:offer-type', value)
          break
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.channel-configuration-fields-container {
  display: flex;
  flex-direction: row;
  gap: 17px;
  margin-top: 14px;
  .field-section {
    display: flex;
    flex-direction: column;
    gap: 4px;
    &-label {
      color: $cinza-d20;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: 0%;
    }
    &-select {
      ::v-deep .v-select__selection,
      ::v-deep i {
        color: $marca-0-l10;
        font-size: 14px;
      }
    }
  }
}
::v-deep fieldset {
  border-color: $marca-0-l10;
}

::v-deep input {
  color: $marca-0-l10 !important;
}

.variant-channels {
  width: 140px;
}
.variant-offer-type,
.variant-fields {
  width: 196px;
}
</style>
